import React from 'react';
import {
    Card,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';

type Props = {
    items: any[];
    allSelected: boolean;
    partiallySelected: boolean;
    onSetSelectedForGroup: (items: any[], checked: boolean) => void;
    analyticsTableSurfaceHeaderBg: string;
    renderRow: (subscriber: any) => React.ReactNode;
};

const SubscriberAnalyticsTableSection = React.memo((props: Props) => {
    const { items, allSelected, partiallySelected, onSetSelectedForGroup, analyticsTableSurfaceHeaderBg, renderRow } = props;

    return (
        <Card sx={{ mb: 1 }}>
            <TableContainer>
                <Table
                    size="small"
                    sx={{
                        borderCollapse: 'separate',
                        borderSpacing: 0,
                        '& .MuiTableBody-root .MuiTableRow-root': { backgroundColor: 'background.paper' },
                        '& .MuiTableBody-root .MuiTableRow-root > .sticky-cell': { backgroundColor: 'background.paper' },
                        '& .MuiTableCell-head': {
                            fontWeight: 700,
                            fontSize: '0.75rem',
                            textTransform: 'uppercase',
                            letterSpacing: '0.04em',
                            color: 'text.secondary',
                            backgroundColor: analyticsTableSurfaceHeaderBg,
                        },
                        '& .sticky-cell-first': { width: 42, minWidth: 42 },
                    }}
                >
                    <TableHead>
                        <TableRow>
                            <TableCell className="sticky-cell sticky-cell-first" padding="checkbox" sx={{ position: 'sticky', left: 0, zIndex: 5, width: 42, minWidth: 42, backgroundColor: analyticsTableSurfaceHeaderBg }}>
                                <Checkbox
                                    checked={allSelected}
                                    indeterminate={partiallySelected}
                                    onChange={(_, checked) => onSetSelectedForGroup(items, checked)}
                                    inputProps={{ 'aria-label': 'Select all subscribers in this group' }}
                                />
                            </TableCell>
                            <TableCell className="sticky-cell" sx={{ position: 'sticky', left: 42, zIndex: 4, backgroundColor: analyticsTableSurfaceHeaderBg }}>Username</TableCell>
                            <TableCell align="right">Subs. Today</TableCell>
                            <TableCell align="right">Fans</TableCell>
                            <TableCell align="right">Following</TableCell>
                            <TableCell align="right">Performer Rank</TableCell>
                            <TableCell align="right">Earnings</TableCell>
                            <TableCell align="right">Chargebacks</TableCell>
                            <TableCell align="right">LTV</TableCell>
                            <TableCell align="right">Tips</TableCell>
                            <TableCell align="right">Messages</TableCell>
                            <TableCell align="right">Posts</TableCell>
                            <TableCell align="right">Subscriptions</TableCell>
                            <TableCell align="right">Stream Tips</TableCell>
                            <TableCell align="right">Referral Earnings</TableCell>
                            <TableCell align="right">Payout Available</TableCell>
                            <TableCell align="right">Payout Pending</TableCell>
                            <TableCell align="right">Referrals Balance</TableCell>
                            <TableCell align="right">Stories Today</TableCell>
                            <TableCell align="right">Posts Today</TableCell>
                            <TableCell align="right">Chats Today</TableCell>
                            <TableCell align="right">Streams Today</TableCell>
                            <TableCell align="right">Visitors</TableCell>
                            <TableCell align="right">Visitor Guests</TableCell>
                            <TableCell align="right">Visitor Users</TableCell>
                            <TableCell align="right">Visitor Subscribers</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>{items.map(renderRow)}</TableBody>
                </Table>
            </TableContainer>
        </Card>
    );
});

SubscriberAnalyticsTableSection.displayName = 'SubscriberAnalyticsTableSection';
export default SubscriberAnalyticsTableSection;
